// Handles main menu accordion action
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dropdown-item.dropdown-toggle').forEach((elem) => {
    elem.addEventListener('click', (e) => {
      e.currentTarget.nextElementSibling.classList.toggle('show');
      e.currentTarget.setAttribute('aria-expanded', (!(e.currentTarget.getAttribute('aria-expanded') == 'true')).toString());
      e.stopImmediatePropagation();
      e.preventDefault();
      return false;
    });
  });
});